import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { selectors, actionCreators } from 'dux/apitokens';
import ApiTokenCard from './ApiTokenCard';

const propTypes = {
  getTokens: PropTypes.func.isRequired,
};

class ApiTokenCardContainer extends Component {
  componentDidMount() {
    const { getTokens } = this.props;
    getTokens();
  }

  render() {
    const { props } = this;
    return <ApiTokenCard {...props} />;
  }
}

const mapStateToProps = (state) => ({
  tokenState: selectors.getApiTokenState(state),
});

const mapDispatchToProps = {
  getTokens: actionCreators.getTokens,
};

ApiTokenCardContainer.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(ApiTokenCardContainer);
